import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import axios from "axios";

export const BASE_URL = "https://api.cncars.kg/api/v1/";

export const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
});

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
  // headers: {
  //   Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  // },
});
